import EventBus from '@/eventBus';

export const CartHelpersVue = {
  data() {
    return {

    }
  },

  methods: {
    setCartId(cartId) {
      if(!$.cookie('cartId')) {
        return $.cookie('cartId', cartId, {expires: 300, path: '/'});
      }
    },

    getCartId() {
      return $.cookie('cartId');
    },

    getCartCount() {
      this.req('CartPage:getCartCount', {}, res => {
        if(this.checkProperty(res.count)) {
          let count = res.count;

          this.$nextTick(() => {
            $('.header__cart-count').text(count);

            if(count > 0) {
              $('.header__cart-count').removeClass('header__cart-count--hide');
            } else {
              $('.header__cart-count').addClass('header__cart-count--hide');
            }
          });
        }
      }, '', 'localPageRequest');
    },

    getAmount(input, type, minAmount) {
      minAmount = (typeof(minAmount) === 'undefined') ? 1 : minAmount;

      let amount = $(input).val();

      if(type === 'minus') {
        amount = amount > minAmount ? --amount : minAmount;
      }

      if(type === 'plus') {
        amount++;
      }

      return amount;
    },

    addToCart(callback, params) {
      this.req('CartPage:addToCart', {...params}, res => {
        if($.isFunction(callback)) {
          callback(res);
        }
      }, '', 'localPageRequest');
    },

    removeFromCart(callback, params) {
      this.req('CartPage:removeFromCart', {...params}, res => {
        if($.isFunction(callback)) {
          callback(res);
        }
      }, '', 'localPageRequest');
    },

    clearCart(callback, params) {
      this.req('CartPage:clearCart', {...params}, res => {
        if($.isFunction(callback)) {
          callback(res);
        }
      }, '', 'localPageRequest');
    },

    saveDeliveryAddress(callback, params) {
      this.req('CartPage:saveDeliveryAddress', {...params}, res => {
        if($.isFunction(callback)) {
          callback(res);
        }
      }, '', 'localPageRequest');
    },

    cartStep(path) {
      this.$router.push({path: path});
    },

    savePaymentMethod(callback, params) {
      this.req('CartPage:savePaymentMethod', {...params}, res => {
        if($.isFunction(callback)) {
          callback(res);
        }
      }, '', 'localPageRequest');
    },

    checkout(callback, params) {
      this.req('CartPage:checkout', {...params}, res => {
        if($.isFunction(callback)) {
          callback(res);
        }
      }, '', 'localPageRequest');
    }
  }
};
